import React, {useRef, useState} from 'react';
import {Route, Routes, useLocation} from 'react-router-dom';
import {Box} from '@mui/material';
import {ROUTES} from '@/config/routesConstants';
import Campaign from '@/views/campaigns/Campaign';
import CampaignStatisticsTab from '@/views/campaigns/statistics-tab/CampaignStatisticsTab';
import CampaignsViewSwitcher from '@/components/campaigns-view-switcher';
import EmberIframe from '@/components/ember-iframe';
import useSetEmberIframeStyles from '@/hooks/use-set-ember-iframe-styles';

const CAMPAIGN_ROUTES = {
  MAIN: '',
  REACT: 'react/*',
  CAMPAIGN: ':campaignId/*',
  STATS_ORGANIC: 'stats/organic',
  // Other routes will be handled by EmberIframe
};

function CampaignRoutes() {
  const location = useLocation();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const emberIframeRef = useRef<HTMLIFrameElement>(null);

  // The V1 list is the Ember iframe, so the switcher can't live in the page
  // body itself — it renders as a strip over the whitespace above the list.
  const isV1CampaignsList =
    location.pathname.replace(/\/$/, '') === ROUTES.CAMPAIGNS;

  useSetEmberIframeStyles(emberIframeRef, iframeLoaded, location);

  const emberIframeRoute = (
    <Route
      path="*"
      element={
        <>
          {isV1CampaignsList && <CampaignsViewSwitcher />}
          <EmberIframe
            iframeRef={emberIframeRef}
            setIframeLoaded={setIframeLoaded}
          />
        </>
      }
    />
  );

  /*
   * Routing Strategy:
   * - React handles specific routes: /campaigns/:id/* and /campaigns/react/*
   * - All other routes fall back to EmberIframe (catch-all * route)
   * - The catch-all is placed within nested routes to ensure proper fallback behavior
   */
  return (
    <Routes>
      <Route
        path={`${CAMPAIGN_ROUTES.MAIN}/${CAMPAIGN_ROUTES.CAMPAIGN}`}
        element={<Campaign />}
      >
        {emberIframeRoute}
        <Route
          path={CAMPAIGN_ROUTES.STATS_ORGANIC}
          element={
            // On the legacy /campaigns/:id/stats/organic route, the surrounding
            // <Campaign> layout doesn't provide horizontal padding (unlike
            // CampaignV2.body, which provides padding: 0 24px on the V2 route).
            // CampaignStatisticsContent intentionally has no inline padding so
            // it doesn't double up on V2; this wrapper supplies the 24px gutter
            // for the standalone route only.
            <Box
              sx={{
                height: '100%',
                paddingInline: '24px',
                boxSizing: 'border-box',
              }}
            >
              <CampaignStatisticsTab />
            </Box>
          }
        />
      </Route>

      <Route
        path={`${CAMPAIGN_ROUTES.MAIN}/${CAMPAIGN_ROUTES.REACT}`}
        element={<div>React /campaigns route</div>}
      />
      {emberIframeRoute}
    </Routes>
  );
}

export default CampaignRoutes;
